(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ww-kbeauty-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ww-kb-menu'))customElements.define('ww-kb-menu',class extends HTMLElement{
connectedCallback(){
this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};const root=this.querySelector('.ww-kbm-root');const trigger=root.querySelector('summary');const desktop=this.classList.contains('ww-kbm--desktop');
this.querySelectorAll('.ww-kbm-group').forEach(group=>{group.open=desktop;if(desktop)group.querySelector('summary').addEventListener('click',event=>event.preventDefault(),options)});
const close=()=>{root.open=false};
this.querySelector('.ww-kbm-mobile-link')?.addEventListener('click',event=>event.stopPropagation(),options);
root.addEventListener('toggle',()=>{trigger.setAttribute('aria-expanded',String(root.open));if(root.open)document.querySelectorAll('ww-kb-menu,ww-utility-menu').forEach(other=>{if(other!==this)other.querySelector('details').open=false})},options);
this.addEventListener('keydown',event=>{if(event.key==='Escape'&&root.open){close();trigger.focus();event.stopPropagation()}},options);
document.addEventListener('pointerover',event=>{if(desktop&&!this.contains(event.target)&&event.target.closest('header-menu,ww-utility-menu'))close()},options);
document.addEventListener('pointerdown',event=>{if(!this.contains(event.target))close()},options);
this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget))close()},options);
this.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{close();this.closest('header-drawer')?.close()},options));
if(desktop){this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){clearTimeout(this.timer);root.open=true;this.hover=true}},options);this.addEventListener('pointerleave',()=>{this.timer=setTimeout(()=>{if(!this.contains(document.activeElement))close();this.hover=false},180)},options);trigger.addEventListener('click',event=>{if(event.detail&&this.hover){event.preventDefault();root.open=true;this.hover=false}},options)}
}
disconnectedCallback(){this.abort?.abort();clearTimeout(this.timer)}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-utility-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ww-utility-menu')) {
    customElements.define('ww-utility-menu', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const alignColumns = () => {
          if (!this.classList.contains('ww-utility-menu--desktop')) return;
          const bar = this.closest('.header__row--top');
          if (!bar) return;
          // Mirror the measured 14.5px outward offset of Beauty beside the Shop All oval.
          const outwardOffset = 14.5;
          const inset = Math.max(28, bar.getBoundingClientRect().right - summary.getBoundingClientRect().right - 1 - outwardOffset);
          this.style.setProperty('--ww-utility-end-inset', `${inset}px`);
          const bridgeHeight = Math.max(0, bar.getBoundingClientRect().bottom - summary.getBoundingClientRect().bottom) + 2;
          this.style.setProperty('--ww-utility-hover-bridge', `${bridgeHeight}px`);
        };
        this.alignmentObserver?.disconnect();
        this.alignmentObserver = new ResizeObserver(alignColumns);
        this.alignmentObserver.observe(summary);
        window.addEventListener('resize', alignColumns, options);
        details.addEventListener('toggle', alignColumns, options);
        alignColumns();
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            details.open = false;
            summary.focus();
            event.stopPropagation();
          }
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) details.open = false;
        }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) details.open = false;
        }, options);
        if (this.classList.contains('ww-utility-menu--desktop')) {
          summary.addEventListener('click', event => {
            if (event.detail > 0 && this.hoverOpened) {
              event.preventDefault();
              details.open = true;
            }
            this.hoverOpened = false;
          }, options);
          this.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && !details.open) {
              this.hoverOpened = true;
              details.open = true;
            }
          }, options);
          this.addEventListener('pointerleave', () => {
            this.hoverOpened = false;
            if (!this.contains(document.activeElement)) details.open = false;
          }, options);
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.alignmentObserver?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
